import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../data/content';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
export function Hero() {
  return <header className="relative isolate overflow-hidden bg-ink-900 pb-16 pt-10 sm:pb-24 sm:pt-14" data-id="element-105" data-mp="9ka4ovgsumvc">
      <img src={images.courtBg} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-[0.28]" data-id="element-106" data-mp="4m8m0bnacpke" />
      <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_0%,rgba(37,89,232,0.35),transparent_60%)]" data-id="element-107" data-mp="1286262e70it6" />
      <div aria-hidden="true" className="absolute inset-x-0 bottom-0 h-48 bg-ink-900/95" style={{
      paddingBottom: "44px"
    }} data-id="element-108" data-mp="x8jnrpmmowis" />

      <div className="relative mx-auto max-w-6xl px-5" data-id="element-109" data-mp="ncq0bb7dfim8">
        <div className="flex justify-center" style={{
        paddingBottom: "6px",
        marginTop: "-20px",
        marginBottom: "-20px"
      }} data-id="element-110" data-mp="neaw145f97lo">
          <span className="inline-flex items-center gap-2 rounded-full border border-ball-400/30 bg-ink-800/80 px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-ball-400 backdrop-blur" data-id="element-111" data-mp="382fgbrjt9agi">
            <span className="h-2 w-2 rounded-full bg-ball-400" aria-hidden="true" data-id="element-112" data-mp="3o7lrppymr4of" />
            Sigma Smart™
          </span>
        </div>

        <h1 className="mt-8 text-center font-display text-4xl uppercase leading-[0.95] text-white sm:text-6xl lg:text-7xl" style={{
        fontSize: "34px"
      }} data-id="element-113" data-mp="399ba3kjqp7ue">
          Resolvé todas tus
          <br className="hidden sm:block" data-id="element-114" data-mp="30hho3ilfz4xf" /> clases de pádel
          <span className="mt-2 block text-ball-400" data-id="element-115" data-mp="30fy8zvbiuzx8">en 5 minutos</span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-slate-300 sm:text-lg" style={{
        fontSize: "14px"
      }} data-id="element-116" data-mp="35a2fkdgvl5xs">
          Planificaciones, técnica, táctica, negocio y seguimiento: todo listo para usar desde hoy.
          <span className="block text-court-200" data-id="element-117" data-mp="2hjf81tavgibr">Sin improvisar. Sin perder tus días libres.</span>
        </p>

        <div className="mt-10 grid items-center gap-10 lg:grid-cols-[1.05fr_1fr]" data-id="element-118" data-mp="2lla5gmpombk9">
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="order-1 lg:order-1" data-id="element-119" data-mp="s1rqcip57wrn">
            <img src={images.heroPack} alt="Padel Pro-Pack: el tomo principal junto a los 5 bonos — Padel Tracker Pro, WhatsApp Sales Scripts, Elite Court Checklist, Nutrition Guide y Video-Analysis Express — sobre una pista de pádel azul" className="mx-auto w-full max-w-xl rounded-2xl" style={{
            marginTop: "-25px",
            marginBottom: "-25px"
          }} data-id="element-120" data-mp="ia5jeyju8jup" />
          </motion.div>

          <div className="order-2 flex flex-col items-center lg:order-2" data-id="element-121" data-mp="111esx7tlz8ma">
            <CtaButton size="lg" href="#cierre" className="w-full max-w-md" data-id="element-122" data-mp="x1nvil9ktu8s">
              🎾 Quiero mi pack ahora
            </CtaButton>
          </div>
        </div>

        <TrustRow className="mt-12" data-id="element-123" data-mp="3lqm3c0xhx9vz" />
      </div>
    </header>;
}